var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3777 4.87265C19.8428 5.34618 19.8428 6.10844 19.3777 6.58198L19.3734 6.58637L13.9443 12.0155L19.3778 17.4455C19.8428 17.919 19.8428 18.6813 19.3777 19.1548L19.3734 19.1592C18.8989 19.6338 18.1299 19.6338 17.6553 19.1592L12.2262 13.7301L6.80071 19.159C6.32615 19.6336 5.55705 19.6338 5.08249 19.1592C4.60792 18.6846 4.60792 17.9157 5.08249 17.4411L10.5116 12.0155L5.08249 6.58635C4.60792 6.11178 4.60792 5.34284 5.08249 4.86828L5.08683 4.86393C5.56037 4.39886 6.32265 4.39888 6.79619 4.86395L6.80073 4.86841L12.2262 10.2974L17.6597 4.86393C18.1332 4.39886 18.8955 4.39888 19.3691 4.86395L19.3777 4.87265Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f7bfe1a7.svg";
export { ForwardRef as ReactComponent };